export const smoothScrollTo = (target: HTMLElement, duration = 800, scrollValue:any) => {
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + window.scrollY;
    const distance = end - start;
    const startTime = performance.now();
  
    const easeInOutQuad = (t: number) =>
      t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  
    const scroll = (currentTime: number) => {
      const time = Math.min((currentTime - startTime) / duration, 1);
      const easedTime = easeInOutQuad(time);
  
      window.scrollTo(0, (start + distance * easedTime) - scrollValue);
  
      if (time < 1) requestAnimationFrame(scroll);
    };
  
    requestAnimationFrame(scroll);
  };
  